import React from 'react'

export default function MobilePortalSearch({
  filter = {},
  onPortalSearchTextChange,
  onSearch,
}) {
  const [value, setValue] = React.useState(filter.title)

  function handleChangeInput(event) {
    const {
      target: { value },
    } = event
    setValue(value)

    if (onPortalSearchTextChange) {
      onPortalSearchTextChange(value)
    }
  }

  return (
    <div className="panel-block">
      <div className="field is-grouped" style={{ width: '100%' }}>
        <div className="control is-expanded">
          <input
            className="input"
            placeholder="search"
            name="portal"
            value={value}
            onChange={handleChangeInput}
          />
        </div>
        <div className="control">
          <div className="button" onClick={() => onSearch(value)}>
            <i className="fas fa-search" aria-hidden="true" />
          </div>
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/templates/mobileHome/MobilePortalSearch.js